/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ./locale-data/complete.js (ignored)
// module id = 4
// module chunks = polyfills